<template>
  <div id="ag-grid-demo">
    <vx-card>
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        :class="{'noDataTable': !list.length}"
        @gridReady="GridReady"
        @filterChanged="Filtering"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        v-if="list.length"
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
import TableMixin from '@/mixins/table.js'
import DateTimeMixin from '@/mixins/datetime.js'

// Packages
import vSelect from 'vue-select'
import { format } from 'date-fns'
import { AgGridVue } from 'ag-grid-vue'
import flatPickr from 'vue-flatpickr-component'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import 'flatpickr/dist/flatpickr.css'

// Cell Renderer components
// import CellRendererActions from './cell-renderer/CellRendererActions'
// import CellRendererStatus from './cell-renderer/CellRendererStatus'

export default {
  mixins: [TableMixin, DateTimeMixin],
  components: {
    AgGridVue,
    flatPickr,
    vSelect,

    // CellRendererLink,
    // CellRendererStatus,
    // CellRendererVerified,
    // CellRendererActions,
  },
  data() {
    return {
      // table header value
      start_time:  new Date().setHours(0, 0, 0),
      end_time:  new Date().setHours(23, 59, 59),
      columnDefs: [
        {
          headerName: 'Time',
          field: 'sms_time',
          minWidth: 260,
          //   filter: true,
          //   cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'From',
          field: 'ani',
          minWidth: 120
        },
        {
          headerName: 'To',
          field: 'dnis',
          minWidth: 120
        },
        {
          headerName: 'Message',
          field: 'sms_content',
          minWidth: 200
        },
      ],

      // Cell Renderer components
      components: {
        // CellRendererActions,
        // CellRendererStatus
      },
      searchProduct: ''
    }
  },
  created() {
    // this.filters.end_time = parseInt((new Date(this.end_time).getTime()/1000))
    // this.filters.start_time = parseInt((new Date(this.start_time).getTime()/1000))
    // this.GetList1()
  },
  methods: {
    SetDatetimeForEnd() {
      this.filters.end_time = parseInt((new Date(this.end_time).getTime()/1000))
    },
    SetDatetimeForStart() {
      this.filters.start_time = parseInt((new Date(this.start_time).getTime()/1000))
    },
    GetListInboundValue() {
      this.$vs.loading()
      this.$store.dispatch('log/GetListInboundValue', {
        ...this.filters,
        page: 0,
        from:0,
        count: 10,
        per_page: this.per_page || 10,
        order_by: this.order_by || 'sms_time',
        order_dir: this.order_dir || 'desc',
        ani: this.searchProduct
      })
        .then(res => {
          this.list = res.data.map(this.TransformReseller)
          this.total = res.total
        })
        .catch()
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    GetList1() {
      // this.$vs.loading()
      this.$store.dispatch('log/GetList1', {
        ...this.filters,
        from:0,
        count: 10,
        page: this.page || 0,
        per_page: this.per_page || 10,
        order_by: this.order_by || 'sms_time',
        order_dir: this.order_dir || 'desc',
        ani: this.searchProduct
      })
        .then(res => {
          this.list = res.data.map(this.TransformReseller)
          this.total = res.total
        })
        .catch()
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    TransformReseller(item) {
      return {
        refreshData: this.GetList,
        ani: format(new Date(item.ani * 1000), 'yyyy-dd-MM HH:mm:ss'),
        dnis: format(new Date(item.dnis * 1000), 'yyyy-dd-MM HH:mm:ss'),
        sms_time:format(new Date(item.sms_time * 1000), 'yyyy-dd-MM HH:mm:ss') ,
        sms_content: item.sms_content
      }
    },
    onQuickFilterChanged() {
      this.filters.ani = parseInt((new Date(this.searchProduct).getTime()/1000))
      this.GetListInboundValue()
    },
  }
}
</script>
<style>
.filter_input_smslog{
  padding: 17px;
  padding-left: 55px;
  width: 300px;
  height: 45px;
  border: 1px solid #f5f5f5;
  font-size: 13px;
  color: gray;
  background-repeat: no-repeat;
  background-position: left center;
  outline: 0;
  margin-top: 2px;
}
.has-search .form-control-smslog-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 15px;
  height: 30px;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: gray;
  margin-left: 35px;
  margin-top: 10px;
}
.sent-btn {
  margin-right: auto!important;
  padding-top: 10px;
}
</style>
